/* istanbul ignore file */
import { DropDownFilter, ConditionProps } from 'framework/list';

import React from 'react';
import CandidateApplicationStatusDropdown from 'domain/recruiting/candidate/applications/shared/input/CandidateApplicationStatusDropdown';

const ApplicationStatusFilter = (props: Omit<ConditionProps, 'children'> & { label: string }) => {
  return (
    <DropDownFilter {...props}>
      <CandidateApplicationStatusDropdown {...props} />
    </DropDownFilter>
  );
};

export default ApplicationStatusFilter;
